<template>
  <div class="install-page">
    <div class="container page d-flex h-100">
      <div class="row w-100 align-items-center">
        <div class="col-md-6 offset-md-3 col-xs-12">
          <card title="Sensoreal Setup" sub-title="Create admin user">
            <p><small>Before proceeding make sure the .env file has been properly configured</small></p>
            <form v-on:submit.prevent="createAdminUser(user);">
              <fieldset class="form-group form-group--sm">
                <label>Username</label>
                <input
                  class="form-control form-control-lg"
                  type="text"
                  v-model="user.username"
                  placeholder="admin"
                  required
                />
              </fieldset>
              <fieldset class="form-group form-group--sm">
                <label>Email</label>
                <input
                  class="form-control form-control-lg"
                  type="email"
                  v-model="user.email"
                  placeholder="name@domain.com"
                  required
                />
              </fieldset>
              <fieldset class="form-group form-group--sm">
                <label>password</label>
                <input
                  class="form-control form-control-lg"
                  type="password"
                  v-model="user.password"
                  placeholder="password"
                  required
                />
              </fieldset>
              <fieldset class="form-group mt-4">
                <button class="btn btn-primary">Begin</button>
              </fieldset>
            </form>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex"
import { CONFIG_ITEM_CREATE, USER_CREATE } from "@/store/actions.type"
import { configs } from '@/common/config.js'

export default {
  data() {
    return {
      user: {
        email: '',
        isAdmin: true,
        password: '',
        username: '',
        access: [
          'users',
          'settings',
          'live',
          'navigation',
          'pages',
          'assets',
          'live-toggle',
          'email-properties'
        ]
      }
    }
  },

  computed: {
    ...mapState({
      errors: state => state.auth.errors,
    })
  },

  methods: {
    createAdminUser(user) {
      this.$store
        .dispatch(USER_CREATE, user)
        .then(async () => {
          this.$notify({
            message: 'New user created',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'success'
          })

          await Promise.all(configs.map(async config => {
            await this.$store.dispatch(CONFIG_ITEM_CREATE, config)
              .then(() => {
                console.log('Config item saved')
              })
              .catch(err => {
                console.log('Error saving config item', err)
              })
          }))

          console.log('All config items saved')

          this.$notify({
            message: 'Saved default config items',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'success'
          })
        })
        .catch(err => {
          this.$notify({
            message: 'Error - ' + err,
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger'
          });
        })
        .finally(() => {
          this.$router.push({ name: "login" })
        })
    }
  }
}
</script>
<style lang="scss" scoped>

.install-page {
  background-color: #dee5ed;
  background-image: linear-gradient(124deg, #dee5ed 0%, #bfdeff 100%);
  height: 100vh;
}
</style>
